import { render, staticRenderFns } from "./CookieBox.vue?vue&type=template&id=49a7739e&scoped=true&"
import script from "./CookieBox.vue?vue&type=script&lang=js&"
export * from "./CookieBox.vue?vue&type=script&lang=js&"
import style0 from "./CookieBox.vue?vue&type=style&index=0&id=49a7739e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a7739e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('49a7739e')) {
      api.createRecord('49a7739e', component.options)
    } else {
      api.reload('49a7739e', component.options)
    }
    module.hot.accept("./CookieBox.vue?vue&type=template&id=49a7739e&scoped=true&", function () {
      api.rerender('49a7739e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25DDahK1afNj0/JS/comp/CookieBox.vue"
export default component.exports